import { Component, type ErrorInfo, type ReactNode } from "react";

import { ServerErrorPage } from "@/pages/ServerErrorPage";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error("ErrorBoundary:", error, info.componentStack);
    }
  }

  handleReset = (): void => {
    this.setState({ error: null });
  };

  render(): ReactNode {
    if (this.state.error) {
      return <ServerErrorPage error={this.state.error} onReset={this.handleReset} />;
    }
    return this.props.children;
  }
}
